import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinsAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCoinsAdd"><Path d="M6 14C6 9.38152 9.47883 5.57556 13.959 5.05956C12.6916 3.78734 10.9377 3 9 3C5.13401 3 2 6.13401 2 10C2 12.9266 3.79594 15.4336 6.34582 16.4793C6.1206 15.6917 6 14.8599 6 14Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 21C18.866 21 22 17.866 22 14C22 10.134 18.866 7 15 7C11.134 7 8 10.134 8 14C8 17.866 11.134 21 15 21ZM16 11H14V13H12V15H14V17H16V15H18V13H16V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoinsAdd;
